__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "cms";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e("vendors-_yarn___virtual___react-dom-virtual-3e16dbed3a_2_root_yarn_berry_cache_react-dom-npm--02af0b"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("root_yarn_berry_cache_object-assign-npm-4_1_1-1004ad6dec-10c0_zip_node_modules_object-assign_-53f7e00")]).then(() => (() => (__webpack_require__(/*! ./.yarn/__virtual__/react-dom-virtual-3e16dbed3a/2/root/.yarn/berry/cache/react-dom-npm-17.0.2-f551215af1-10c0.zip/node_modules/react-dom/index.js */ "./.yarn/__virtual__/react-dom-virtual-3e16dbed3a/2/root/.yarn/berry/cache/react-dom-npm-17.0.2-f551215af1-10c0.zip/node_modules/react-dom/index.js"))))));
			register("react", "17.0.2", () => (Promise.all([__webpack_require__.e("vendors-root_yarn_berry_cache_react-npm-17_0_2-99ba37d931-10c0_zip_node_modules_react_index_js"), __webpack_require__.e("root_yarn_berry_cache_object-assign-npm-4_1_1-1004ad6dec-10c0_zip_node_modules_object-assign_-53f7e01")]).then(() => (() => (__webpack_require__(/*! ../root/.yarn/berry/cache/react-npm-17.0.2-99ba37d931-10c0.zip/node_modules/react/index.js */ "../root/.yarn/berry/cache/react-npm-17.0.2-99ba37d931-10c0.zip/node_modules/react/index.js"))))));
			register("single-spa-react", "3.2.0", () => (__webpack_require__.e("_yarn___virtual___single-spa-react-virtual-82ebfc94dc_2_root_yarn_berry_cache_single-spa-reac-2f9d3d").then(() => (() => (__webpack_require__(/*! ./.yarn/__virtual__/single-spa-react-virtual-82ebfc94dc/2/root/.yarn/berry/cache/single-spa-react-npm-3.2.0-788d62cdd8-10c0.zip/node_modules/single-spa-react/lib/esm/single-spa-react.js */ "./.yarn/__virtual__/single-spa-react-virtual-82ebfc94dc/2/root/.yarn/berry/cache/single-spa-react-npm-3.2.0-788d62cdd8-10c0.zip/node_modules/single-spa-react/lib/esm/single-spa-react.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};